import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {
  EmBoxModule,
  EmButtonModule,
  EmCheckboxModule,
  EmIconModule,
  EmInputModule,
  EmSelectModule,
} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';
import {EmSelectOperandModule} from '../select-operand/select-opearnd.module';
import {EmMappingRuleListComponent} from './mapping-rule-list.component';
import {EmMappingRuleComponent} from '../mapping-rule/mapping-rule.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatIconModule,
    MatTooltipModule,
    EmSelectModule,
    EmBoxModule,
    EmButtonModule,
    EmMappingRuleComponent,
    EmSelectOperandModule,
    EmCheckboxModule,
    EmInputModule,
    EmIconModule,
  ],
  declarations: [EmMappingRuleListComponent],
  exports: [EmMappingRuleListComponent],
})
export class EmMappingRuleListModule {}
